'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp2;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterRedux = require('react-router-redux');

var _helpers = require('helpers');

var _constants = require('redux/constants');

var _catalog = require('redux/actions/catalog');

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Category: {
        displayName: 'Category'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Category/Category.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Category = _wrapComponent('Category')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var id = params.id,
            limit = parseInt(location.query.limit, 10) || _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT,
            page = parseInt(location.query.page, 10) || 1;

        if (limit > _constants.CatalogNumericConstants.MAX_LIMIT) {
            limit = _constants.CatalogNumericConstants.CATEGORY_PAGE_LIMIT;
        }
        if (page > _constants.CatalogNumericConstants.MAX_PAGE) {
            page = 1;
        }

        return dispatch((0, _extends3.default)({}, (0, _catalog.getProductByCategory)({ id: id, page: --page, limit: limit }), { show_404: location.pathname }));
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        setting: state.setting,
        catalog: state.catalog,
        lang: state.lang
    };
}, { getProductByCategory: _catalog.getProductByCategory, getCategoryRecommended: _catalog.getCategoryRecommended, push: _reactRouterRedux.push }), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(Category, _Component);

    function Category() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Category);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Category.__proto__ || (0, _getPrototypeOf2.default)(Category)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChangePage = function (page, limit) {
            _this.props.push('/category/' + _this.props.catalog.id + '?limit=' + limit + '&page=' + page);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Category, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$catalog = this.props.catalog,
                categorySeo = _props$catalog.categorySeo,
                limit = _props$catalog.limit,
                activePage = _props$catalog.activePage,
                id = _props$catalog.id,
                recommendedId = _props$catalog.recommendedId;

            history.replaceState(null, null, '/category/' + (categorySeo && categorySeo.semantic_url ? categorySeo.semantic_url : id) + '?limit=' + limit + '&page=' + activePage);

            if (id && id !== recommendedId) {
                this.props.getCategoryRecommended(id);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForContainer('Category');

            var _props$catalog2 = this.props.catalog,
                activePage = _props$catalog2.activePage,
                categoryRecommended = _props$catalog2.categoryRecommended,
                categoryPreload = _props$catalog2.categoryPreload,
                categoryId = _props$catalog2.categoryId,
                count = _props$catalog2.count,
                id = _props$catalog2.id,
                limit = _props$catalog2.limit,
                products = _props$catalog2.products,
                title = _props$catalog2.title,
                description = _props$catalog2.description,
                picture = _props$catalog2.picture;
            var lang = this.props.lang;

            var categorySeo = this.props.catalog.categorySeo || {};
            var headTitle = categorySeo && categorySeo.title || title;
            var orderInOneClick = this.props.setting.orderInOneClick;
            var buyInCreditActive = this.props.setting.buyInCreditActive;
            var meta = [];

            if (categorySeo.description) {
                meta.push({ name: "description", content: categorySeo.description });
            }
            if (categorySeo.keywords) {
                meta.push({ name: "keywords", content: categorySeo.keywords });
            }
            if (categorySeo.indexation === false) {
                meta.push({ name: "robots", content: 'noindex, nofollow' });
            }

            return _react3.default.createElement(
                'div',
                { className: 'tab-content' },
                _react3.default.createElement(_reactHelmet2.default, { title: headTitle }),
                meta.length > 0 ? _react3.default.createElement(_reactHelmet2.default, { meta: meta }) : null,
                _react3.default.createElement(View, {
                    activePage: activePage,
                    count: count,
                    limit: limit,
                    products: products,
                    title: categorySeo && categorySeo.h1 || lang[title] || title,
                    picture: picture,
                    description: description,
                    handleChangePage: this.handleChangePage,
                    sliderContent: categoryRecommended,
                    orderInOneClick: orderInOneClick,
                    buyInCreditActive: buyInCreditActive,
                    preload: categoryPreload,
                    lang: lang
                })
            );
        }
    }]);
    return Category;
}(_react2.Component), _class2.propTypes = {
    getProductByCategory: _react2.PropTypes.func.isRequired
}, _temp2)) || _class) || _class));

exports.default = Category;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Category/Category.jsx
// module id = 1806
// module chunks = 0